import React, { useContext, useMemo } from 'react';
import useAvailableFromAssets from '../hooks/use-available-from-assets.js';
import useAvailableToAssets from '../hooks/use-available-to-assets.js';
const initialValue = {
    fromAssets: {
        value: null,
        loading: true,
    },
    toAssets: {
        value: null,
        loading: true,
    },
};
const AssetsContext = React.createContext(initialValue);
export const useFromAssets = () => useContext(AssetsContext).fromAssets;
export const useToAssets = () => useContext(AssetsContext).toAssets;
export const AssetsProvider = ({ children }) => {
    const fromAssets = useAvailableFromAssets();
    const toAssets = useAvailableToAssets();
    const contextValue = useMemo(() => ({ fromAssets, toAssets }), [fromAssets, toAssets]);
    return React.createElement(AssetsContext.Provider, { value: contextValue }, children);
};
